export enum MultipleChoiceViewType {
    LIST = "LIST",
    SCALE = "SCALE",
}
